import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationEN from "./locales/en/translation.json";
import translationDE from "./locales/de/translation.json";
import translationNL from "./locales/nl/translation.json";

const resources = {
  en: { translation: translationEN },
  de: { translation: translationDE },
  nl: { translation: translationNL },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "de", // default language
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // react already escapes
    },
  });

export default i18n;